import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import * as fromProfile from '../../store/profile.reducers';
import {Chart} from 'angular-highcharts';
import {Store} from '@ngrx/store';
import * as fromApp from '../../../store/app.reducers';
import {ChartService} from '../../chart.service';

@Component({
    selector: 'app-profile-media-engage-week-day',
    templateUrl: './profile-media-engage-week-day.component.html',
    styleUrls: ['./profile-media-engage-week-day.component.scss'],
    standalone: false
})
export class ProfileMediaEngageWeekDayComponent implements OnInit, OnDestroy {

  profileState: Observable<fromProfile.State>;
  chartsFollowerEngage: Chart[];
  profileSubscription: Subscription;

  constructor(
    private store: Store<fromApp.AppState>,
  ) { }

  ngOnInit() {
    this.profileState = this.store.select('profile');

    this.profileSubscription = this.store.select('profile').subscribe(
      (state: fromProfile.State) => {
        if (state.followerEngage !== null) {
          this.chartsFollowerEngage = [];
          this.chartsFollowerEngage.push(
            ChartService.getEngageByWeekDayChart(state.followerEngage)
          );
        }

      }
    );
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

}
